import { Injectable } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { App } from '@capacitor/app';

@Injectable({
    providedIn: 'root',
})
export class GlobalService {
    public Version = '3.4.41'; // fallback version for web and in case native call fails
    public appInfo: any = null;

    public latestVersion = '';
    public apkurl = '';
    public apkDownload = false;
    public MyPlatform = 'android'; // 'android'; // 'ios';
    public App = 'BAR3';
    public devID = '';
    public devInfo = '';

    public baseurl = 'https://cloud.lisaas.com/lipronics/';

    public isLoggedIn = false;
    public compname: string;
    public username: string;
    public password: string;
    public usrvalue: string;
    public usrlevel: number;
    public session: string;
    public uuid: string;
    public var: string[];
    public modules: string[];
    public language = 'nl';
    public txt: string[]; // vertalingen worden hierin geladen
    public experimentalFeatures = false;

    public optHideScanBtn: boolean;
    public optAfbV2: boolean;
    public startPage = '/home';
    public optInclBtw: boolean = false;
    public scanCamera = false;

    public currArtNr: string;
    public currProjNr: string;
    public currBedr: string;
    public currObject: string;

    // ? profile switching stuffs
    public profileManagementEnabled = false;
    public profiles: any[] = [];
    public lastActiveProfile: any = null;

    // ? calendar setting
    public showCalendar: boolean;

    viewerOpen = false;

    constructor(
        public alertController: AlertController,
        public modalController: ModalController
    ) {
        this.profileManagementEnabled =
            localStorage.getItem('profileManagementEnabled') === '1';
        this.loadProfiles();
        this.showCalendar = localStorage.getItem('showCalendar') === '1';
        this.loadAppVersion();
    }

    async loadAppVersion() {
        try {
            this.appInfo = await App.getInfo();
            this.Version = this.appInfo.version;
            console.log('App version loaded from native:', this.Version);
        } catch (error) {
            console.error('Failed to load app version from native, using fallback:', error);
            // Keep the fallback version if native call fails
        }
    }

    getAppName(): string {
        return this.appInfo?.name || 'Lisaas Voorraad';
    }

    getBuildNumber(): string {
        return this.appInfo?.build || 'unknown';
    }

    getAppId(): string {
        return this.appInfo?.id || 'com.lisaas.bar';
    }

    getvar(varname: string, defaultValue = '') {
        if (this.var && varname in this.var) {
            return this.var[varname];
        } else {
            return defaultValue;
        }
    }

    getmod(module: string) {
        if (this.modules) {
            if (this.modules[module]) {
                return this.modules[module];
            } else {
                return 0;
            }
        } else {
            return 0;
        }
    }

    async loadProfiles() {
        try {
            const result = await SecureStoragePlugin.get({
                key: 'userProfiles',
            });
            if (result.value) {
                this.profiles = JSON.parse(result.value);
            } else {
                this.profiles = []; // ?  empty if nothing is stored
            }
        } catch (error) {
            console.error(
                'Failed to load secure profiles, defaulting to empty.',
                error
            );
            this.profiles = [];
        }
    }

    async saveProfiles() {
        try {
            await SecureStoragePlugin.set({
                key: 'userProfiles',
                value: JSON.stringify(this.profiles),
            });
        } catch (error) {
            console.error('Failed to save secure profiles.', error);
        }
    }

    addProfile(newProfile: any) {
        // ? prevent duplicates by finding if a profile for that user/company already exists
        const existingIndex = this.profiles.findIndex(
            (p) =>
                p.company === newProfile.company &&
                p.username === newProfile.username
        );

        if (existingIndex > -1) {
            // ?if it exists, update it (e.g., if the password changed)
            this.profiles[existingIndex] = newProfile;
        } else {
            this.profiles.push(newProfile);
        }
        this.saveProfiles();
    }

    removeProfile(profileToRemove: any) {
        this.profiles = this.profiles.filter(
            (p) =>
                p.company !== profileToRemove.company ||
                p.username !== profileToRemove.username
        );
        this.saveProfiles();
    }

    async switchProfile(profileToSwitchTo: any) {
        localStorage.setItem('company', profileToSwitchTo.company);
        localStorage.setItem('user', profileToSwitchTo.username);

        await SecureStoragePlugin.set({
            key: 'password',
            value: profileToSwitchTo.password,
        });

        localStorage.setItem('autoLogin', '1');
    }

    async prepareToAddProfile() {
        const currentUserProfile = this.profiles.find(
            (p) => p.username === this.username && p.company === this.compname
        );

        this.lastActiveProfile = currentUserProfile || null;

        localStorage.removeItem('company');
        localStorage.removeItem('user');
        await SecureStoragePlugin.remove({ key: 'password' });
        localStorage.removeItem('autoLogin');
        this.isLoggedIn = false;
        this.username = null;
        this.compname = null;

        console.log('Saved last active profile and ended session.');
    }

    async logout() {
        this.isLoggedIn = false;
        this.username = null;
        this.compname = null;
        console.log('Full logout complete. All profiles were kept.');
    }
}
